export const updateTransParams = (params) => {
  return (dispatch) => {
    dispatch({ type: "TRANS_PARAMS", payload: params });
  };
};
